// extracted by mini-css-extract-plugin
module.exports = {"badgesWrap":"Badges_badgesWrap__swSaH","badge":"Badges_badge__s9AVX","slide-in-out":"Badges_slide-in-out__O8bTc","fade-in-out":"Badges_fade-in-out__xNVYl"};